// Import Libraries
import React, { useContext } from 'react';
import { Badge, ToggleButton, ToggleButtonGroup, Tooltip } from '@mui/material';
import ViewModuleOutlinedIcon from '@mui/icons-material/ViewModuleOutlined';
import TableChartOutlinedIcon from '@mui/icons-material/TableChartOutlined';
import ViewListOutlinedIcon from '@mui/icons-material/ViewListOutlined';

// Context
import ProjectViewContext from '../../../context/ProjectView';

// Import Services
import UserService from '../../../services/userService';

// Construct Component
const ViewToggle = () => {
  const { view, setView } = useContext(ProjectViewContext);

  const value = view.tableView ? 'table' : view.viewColumns === 1 ? 'list' : 'cards';

  const handleChange = (_, next) => {
    // Exclusive group: clicking the selected button would deselect it.
    if (!next || next === value) return;
    if (next === 'table') {
      UserService.addActionLog('Clicked Table View');
      setView((prev) => ({ ...prev, tableView: true }));
    } else {
      setView((prev) => ({ ...prev, tableView: false, viewColumns: next === 'list' ? 1 : 2 }));
    }
  };

  return (
    <ToggleButtonGroup exclusive value={value} onChange={handleChange} aria-label="Project view">
      <Tooltip title="Cards">
        <ToggleButton value="cards" aria-label="Cards view">
          <ViewModuleOutlinedIcon />
        </ToggleButton>
      </Tooltip>
      <Tooltip title="Table (beta)">
        <ToggleButton value="table" aria-label="Table view (beta)">
          <Badge badgeContent="BETA" color="primary">
            <TableChartOutlinedIcon />
          </Badge>
        </ToggleButton>
      </Tooltip>
      <Tooltip title="List">
        <ToggleButton value="list" aria-label="List view">
          <ViewListOutlinedIcon />
        </ToggleButton>
      </Tooltip>
    </ToggleButtonGroup>
  );
};

export default ViewToggle;
